import React from 'react'
import { Typography } from 'antd'
import PropTypes from 'prop-types'

import { StyledSearchHighlightedSpan } from '../styled'

const TreeSelectNodeTitle = ({ title, searchValue, isMuted }) => {
  if (!searchValue) {
    return (
      <div>
        <Typography.Text disabled={isMuted}>{title}</Typography.Text>
      </div>
    )
  }

  const startIndex = title.toLowerCase().indexOf(searchValue.toLowerCase())
  const endIndex = startIndex + searchValue.length

  return (
    <div>
      {startIndex !== 0 && (
        <Typography.Text disabled={isMuted}>
          {title.substring(0, startIndex)}
        </Typography.Text>
      )}

      <StyledSearchHighlightedSpan>
        <Typography.Text disabled={isMuted}>
          {title.substring(startIndex, endIndex)}
        </Typography.Text>
      </StyledSearchHighlightedSpan>

      {endIndex < title.length && (
        <Typography.Text disabled={isMuted}>
          {title.substring(endIndex, title.length)}
        </Typography.Text>
      )}
    </div>
  )
}

TreeSelectNodeTitle.propTypes = {
  title: PropTypes.string,
  searchValue: PropTypes.string,
  isMuted: PropTypes.bool,
}

TreeSelectNodeTitle.defaultProps = {
  title: '',
  searchValue: null,
  isMuted: false,
}

export default TreeSelectNodeTitle
